<template>
  <div>
    <header
      class="md:p-2 h-102 text-white flex flex-col md:justify-between md:flex-col md:items-end items-center"
    >
      <div v-if="isMetaMaskInstalled()" class="items-end px-4 py-2 border border-white">
          <div v-if="walletConnected">
              {{ activeAddress }}
          </div>
          <div v-else>
            <button :disabled="walletConnecting" href="#" @click.prevent="onConnectWallet"> Connect metamask </button>
          </div>
      </div>
      <div v-else>
        Metamask not installed
      </div>
      <div class="self-center">
        <img width="900" src="https://fantomwheelz.com/assets/images/fantomwheelz_header_05.png" />
      </div>

      <div class="flex flex-col items-end md:flex-row md:justify-end mb-4">
        <router-link class="hover:underline px-2 text-xl font-bold text-yellow-300" to="/"
          >HOME</router-link
        > <span class="hidden md:block">|</span>
        <router-link class="hover:underline px-2 text-xl font-bold text-yellow-300" to="/mywheelz"
          >MY CARAGE</router-link
        > <span class="hidden md:block">|</span>
        <router-link
          class="hover:underline px-2 text-xl font-bold text-yellow-300"
          to="/attribute_gallery"
          >SHOWROOM</router-link
        > <span class="hidden md:block">|</span>
        <router-link
          class="hover:underline px-2 text-xl font-bold text-yellow-300"
          to="/limited_editions"
          >LIMITED EDITIONs</router-link
        > <span class="hidden md:block">|</span>
        <router-link class="hover:underline px-2 text-xl font-bold text-yellow-300" to="/roadmap"
          >ROADMAP</router-link
        > <span class="hidden md:block">|</span>
        <router-link
          class="hover:underline px-2 text-xl font-bold text-yellow-300"
          to="/team"
          >TEAM</router-link
        > <span class="hidden md:block">|</span>
        <a
          class="hover:underline px-2 text-xl font-bold text-white"
          href="https://spookyswap.finance/swap"
          >BUY FTM</a
        > 
      </div>
    </header>
    <hr class="headerspacer" />
  </div>
</template>
<script>
import {
  isMetaMaskConnected,
  isMetaMaskInstalled,
  connectWallet,
  showStartAndEnd
} from '../walletHelpers.js'
export default {
  data: function () {
    return {
      showWalletDialog: false,
      walletConnected: false,
      activeAddress: null,
      walletConnecting: false,
    }
  },
  computed: {
  },
  mounted () {
    isMetaMaskConnected().then((ret) => {
      this.walletConnected = ret
      if (this.walletConnected) {
        this.metamaskSelectedAddress()
      }
    })
  },
  methods: {
    metamaskSelectedAddress: function () {
      const { ethereum } = window
      if (ethereum != null) {
        ethereum.request({ method: 'eth_accounts' })
          .then((ret) => {
            if (ret.length > 0) {
              const addr = ret[0]
              this.activeAddress = showStartAndEnd(addr)
            }
          })
      } else {
        return 'Connect metamask'
      }
    },
    isMetaMaskInstalled: function () { return isMetaMaskInstalled() },
    isMetaMaskConnected: function () { return isMetaMaskConnected() },
    showStartAndEnd: function (addr) { return showStartAndEnd(addr) },
    onConnectWallet: function () {
      this.walletConnecting = true
      connectWallet().then((ret) => {
        this.walletConnected = ret
        this.metamaskSelectedAddress()
      })
    }
  },
  components: {}
}
</script>
<style scoped>
header {
  background-color: #ff4f31;
}
.headerspacer {
  border: 4px solid #fdce44;
}
</style>



// WEBPACK FOOTER //
// src/components/WheelzHeader.vue